module.exports = __webpack_public_path__ + "img/ibm.8e9b96f7.svg";